<script>
  import { onMount } from "svelte";

  import Input from "../ui/Input.svelte";
  import Button from "../ui/Button.svelte";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
  const save = () => dispatch("save");

  export let model;
  export let darkMode = false;
  export let noHeadline = false;

  function handleSubmit() {
    save();
  }
  let buttonStyle = `min-width:60px;`;

  onMount(() => {
    if (darkMode) {
      buttonStyle = `${buttonStyle} color:#000000!important; background:white!important`;
    }
  });
</script>

<div>
  {#if !noHeadline}
    <h2 class="text-2xl leading-7">
      Be the first to <span class="font-bold"
        >create all your marketing assets in minutes</span
      >
      when GETitOUT launches in <span class="font-bold">April 2021</span>.
    </h2>
  {/if}
  <div class="mt-6">
    <form class="sm:flex sm:flex-row" on:submit|preventDefault={handleSubmit}>
      <Input
        bind:model={model.firstName}
        required={true}
        placeholder="First Name"
        class="mr-2 text-main sm:flex-1 mb-2 sm:w-auto sm:mb-0 w-full"
      />
      <Input
        bind:model={model.email}
        type="email"
        required={true}
        placeholder="Email"
        class="mr-2 text-main sm:flex-1 mb-2 sm:w-auto sm:mb-0 w-full"
      />
      <Button
        class="sm:w-auto w-full"
        type="submit"
        primary={true}
        raised={true}
        style={buttonStyle}>I'm in</Button
      >
    </form>
  </div>
  <div class="mt-2 text-sm">
    You’ll receive monthly updates and your personal invitation via email.
  </div>
</div>
